export default "__VITE_ASSET__DyenRbNw__"